<script>
import { formatPriceWithSign } from '@/utils/helpers'
import SidebarPenalties from '@/components/views/penalties/SidebarPenalties.vue'
import {
  rexDropdown
} from '@/components/views/rexField'

export default {
  name: 'sidebar',
  components: {
    SidebarPenalties,
    rexDropdown
  },
  computed: {
    currencies() {
      return this.$store.getters.getDictionary('cart.dictionaries.currencies')
    },
    hasBookedServices() {
      return this.$store.getters['order/hasBookedServices']
    },
    getBookingsCurrencies() {
      return this.$store.getters['order/getInclude'].currencies.map(item => ({
        slug: item,
        name: `${this.currencies.find(currency => currency.slug === item).sign} ${item}`
      }))
    },
    orderInfo() {
      return this.$store.getters['order/getOrderInfo']
    },
    getComputedBookingPrices() {
      return this.$store.getters['order/getOrderPrice']
    },
    isLoading() {
      return this.$store.getters['order/isLoading']
    }
  },
  methods: {
    changeCurrency(currency) {
      this.$store.dispatch('order/getOrder', {
        id: this.orderInfo.id,
        params: {
          currency
        }
      })
    },
    formatPrice(price) {
      const { currency } = this.getComputedBookingPrices

      return formatPriceWithSign(price, currency, this.currencies)
    },
    currenciesLabelFormatter(label) {
      return label.split(' ')[0]
    },
    bookingsStatusName(statusId) {
      return this.$store.getters['order/getInclude'].orderStatuses[statusId]
    },
    openPaymentMethodSelectForm() {
      const {
        orderId,
        price,
        paymentHash
      } = this.orderInfo

      this.$store.commit('payment/setMethodSelectForm', {
        sum: price.amount,
        isActive: true,
        orderId
      })

      this.$store.commit('payment/setBillingData', {
        paymentHash
      })

      const collection = this.$store.getters['payment/methodSelectForm'].paymentSuppliers

      if (!collection.length) {
        this.$store.commit('payment/setMethodSelectForm', {
          isLoading: true
        })

        this.$store.dispatch('payment/getSuppliers')
      }
    }
  }
}
</script>

<template>
  <div class="order-sidebar">
    <div class="order-sidebar__content">
      <h2 class="order__title">
        Заказ № {{ orderInfo.id }}
      </h2>
      <div class="order-sidebar__details">
        <div
          v-if="hasBookedServices"
        >
          <div class="order-sidebar__info">
            <span class="order-sidebar__info-label">
              Статус заказа
            </span>
            <span class="order-sidebar__info-value order-sidebar__info-value--with-icon">
              {{ bookingsStatusName(orderInfo.status) }}
            </span>
          </div>
          <div class="order-sidebar__info">
            <span class="order-sidebar__info-label">
              Статус оплаты
            </span>
            <span class="order-sidebar__info-value order-sidebar__info-value--with-icon">
              {{ orderInfo.price.status }}
            </span>
          </div>
          <div class="order-sidebar__info">
            <span class="order-sidebar__info-label">
              Даты поездки
            </span>
            <span class="order-sidebar__info-value">
              {{ orderInfo.startDate }} - {{ orderInfo.endDate }}
            </span>
          </div>
        </div>
        <div class="order-sidebar__info">
          <span class="order-sidebar__info-label">
            Сформирован
          </span>
          <span class="order-sidebar__info-value">
            {{ orderInfo.createDate }}
          </span>
        </div>
        <div class="order-sidebar__info">
          <span class="order-sidebar__info-label">
            Компания
          </span>
          <span class="order-sidebar__info-value">
            {{ orderInfo.manager.agency }}
          </span>
        </div>
      </div>
      <div
        v-if="hasBookedServices"
      >
        <h2 class="order__title order-sidebar__title--detailed">
          <span>Детализация заказа</span>
          <rex-dropdown
            v-if="currencies.length"
            name="order-currency-dropdown"
            store-module="order"
            getter-name="getServiceField"
            setter-name="updateServiceField"
            position="is-bottom-left"
            target="orderCurrency"
            :custom-label="true"
            css-class="order-sidebar__currencies-dropdown"
            :label-formatter="currenciesLabelFormatter"
            :data="getBookingsCurrencies"
            @onChange="changeCurrency($event)"
          />
        </h2>
        <div
          v-if="!isLoading"
          class="order-sidebar__details"
        >
          <div class="order-sidebar__details-item">
            <div class="order-sidebar__details-item-label">
              Полная стоимость
            </div>
            <div class="order-sidebar__details-item-value">
              {{ formatPrice(getComputedBookingPrices.amount) }}
            </div>
          </div>
          <div class="order-sidebar__details-item">
            <div class="order-sidebar__details-item-label">
              Сумма комиссии
            </div>
            <div class="order-sidebar__details-item-value">
              {{ formatPrice(getComputedBookingPrices.markup) }}
            </div>
          </div>
          <div class="order-sidebar__details-item">
            <div class="order-sidebar__details-item-label">
              Стоимость
            </div>
            <div class="order-sidebar__details-item-value">
              {{ formatPrice(getComputedBookingPrices.amountAgency) }}
            </div>
          </div>
          <div class="order-sidebar__details-item">
            <div class="order-sidebar__details-item-label">
              Оплачено
            </div>
            <div class="order-sidebar__details-item-value">
              {{ formatPrice(0) }}
            </div>
          </div>
          <div class="order-sidebar__details-item">
            <div class="order-sidebar__details-item-label">
              К оплате
            </div>
            <div
              class="
                order-sidebar__details-item-value
                order-sidebar__details-item-value--accent
              "
            >
              {{ formatPrice(orderInfo.price.debt) }}
            </div>
          </div>
          <div class="order-sidebar__details-item">
            <div class="order-sidebar__details-item-label">
              Срок предоплаты до
            </div>
            <div class="order-sidebar__details-item-value">
              {{ orderInfo.prepaymentDate }}
            </div>
          </div>
          <div class="order-sidebar__details-item">
            <div class="order-sidebar__details-item-label">
              Срок полной оплаты до
            </div>
            <div class="order-sidebar__details-item-value">
              {{ orderInfo.paymentDate }}
            </div>
          </div>
        </div>
      </div>
      <h2 class="order__title">
        Ведущий менеджер в РЭ
      </h2>
      <div class="order-sidebar__manager">
        <p>{{ orderInfo.manager.name }}</p>
        <p>{{ orderInfo.manager.phone }}</p>
      </div>
      <div
        v-if="hasBookedServices"
      >
        <a
          href="javascript:;"
          class="rex-rounded-field--btn order-sidebar__action"
          @click="openPaymentMethodSelectForm"
        >
          Оплатить
        </a>
        <div class="order-sidebar__links">
          <sidebar-penalties
            store-module="order"
            getter-name="getAllBookingsPenalties"
          />
        </div>
      </div>
    </div>
  </div>
</template>
